import { useContext } from 'react';
import { TableStoreContext } from '../../../stores/TableStoreContext';
import { TableRowItemCombinedProps } from './types';

const usePresenter = (props: TableRowItemCombinedProps): TableRowItemCombinedProps => {
  const { index } = props;
  const tableStore = useContext(TableStoreContext);

  const toggleHoverRow = (hovered: boolean) => {
    if (tableStore.selectedRow === index || index === undefined) {
      return;
    }

    if (hovered) {
      tableStore.updateRowState('Default', index);
      tableStore.setHoveredRow(index);
      return;
    }

    tableStore.setHoveredRow(undefined);
    tableStore.resetRowState(index);
  };

  const handleMouseEnter = () => {
    toggleHoverRow(true);
  };

  const handleMouseLeave = () => {
    toggleHoverRow(false);
  };

  return {
    ...props,
    handleMouseEnter,
    handleMouseLeave,
  };
};

export default usePresenter;
